// @flow
import { createAction } from 'redux-actions';
import type { ClientCatalog } from './types';

// profiles
export const fetchClientCatalog = createAction(
  '@client/catalog/fetch',
  (clientId: Id) => clientId
);

export const storeClientCatalog = createAction(
  '@client/catalog/store',
  (payload: Array<ClientCatalog>) => payload,
  (_, clientId: Id) => clientId
);

export const selectClientCatalog = createAction(
  '@client/catalog/select',
  (catalogId: Id) => catalogId
);



// WEBPACK FOOTER //
// ./src/containers/client/catalogActions.js